var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.515625 13.4836H3.00411V13.9882H1.75987V14.9974H3.00411V15.502H0.515625V16.5112H4.24835V12.4744H0.515625V13.4836ZM1.75987 4.40098H3.00411V0.364258H0.515625V1.37344H1.75987V4.40098ZM0.515625 7.42852H2.75526L0.515625 9.5478V10.4561H4.24835V9.44689H2.00872L4.24835 7.32761V6.41934H0.515625V7.42852ZM6.73684 1.37344V3.3918H24.1562V1.37344H6.73684ZM6.73684 15.502H24.1562V13.4836H6.73684V15.502ZM6.73684 9.44689H24.1562V7.42852H6.73684V9.44689Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderedList);
export default __webpack_public_path__ + "static/media/ordered-list.dfd6dd80890c2cb86b890a94e6b6efe4.svg";
export { ForwardRef as ReactComponent };